import styled from 'styled-components';

export const StyledPractitionerName = styled.div`
   width: 335px;
`;
StyledPractitionerName.displayName = 'StyledPractitionerName';
